import { render, staticRenderFns } from "./resetPasswordComponent.vue?vue&type=template&id=5f7cc9cb&scoped=true"
import script from "./resetPasswordComponent.vue?vue&type=script&lang=js"
export * from "./resetPasswordComponent.vue?vue&type=script&lang=js"
import style0 from "./resetPasswordComponent.vue?vue&type=style&index=0&id=5f7cc9cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7cc9cb",
  null
  
)

export default component.exports